window.initPostForm = function() {
  initMultipleSelect();
  initDatepicker();
  tinyMceFull();
}
